import { getConfig } from '../config';

const RESERVED_HOST_LABELS = new Set(['app', 'www']);

/**
 * Extrai o label de subdominio do tenant a partir do hostname, ou null.
 * Retorna null para: baseDomain vazio, host fora do baseDomain, apex,
 * label multi-nivel, e os hosts genericos reservados (app/www).
 */
export function getTenantSubdomain(hostname: string, baseDomain: string): string | null {
  if (!baseDomain) return null;
  const host = hostname.trim().toLowerCase();
  const base = baseDomain.trim().toLowerCase();
  const suffix = '.' + base;
  if (!host.endsWith(suffix)) return null;
  const label = host.slice(0, host.length - suffix.length);
  if (label.length === 0) return null;        // apex
  if (label.includes('.')) return null;        // multi-level (ex.: a.b)
  if (RESERVED_HOST_LABELS.has(label)) return null; // app/www generic host
  return label;
}

export function getCurrentTenantSubdomain(): string | null {
  let baseDomain = '';
  try { baseDomain = getConfig().baseDomain ?? ''; } catch { baseDomain = ''; }
  if (typeof window === 'undefined') return null;
  return getTenantSubdomain(window.location.hostname, baseDomain);
}

export function getGenericPortalUrl(): string | null {
  let baseDomain = '';
  try { baseDomain = getConfig().baseDomain ?? ''; } catch { baseDomain = ''; }
  const base = baseDomain.trim().toLowerCase();
  if (!base) return null;
  return `https://app.${base}/`;
}

/**
 * URL completa do subdominio de um tenant: https://{subdomain}.{baseDomain}.
 * Retorna null quando o baseDomain nao esta configurado (ex.: dev), para o
 * caller degradar (ex.: copiar apenas o label).
 */
export function getTenantSubdomainUrl(subdomain: string): string | null {
  let baseDomain = '';
  try { baseDomain = getConfig().baseDomain ?? ''; } catch { baseDomain = ''; }
  const base = baseDomain.trim().toLowerCase();
  if (!base) return null;
  return `https://${subdomain}.${base}`;
}
